import { gql, useQuery } from "@apollo/client";

const GET_NEAREST_TRIAL_SITE = gql`
  query GetNearestTrialSite(
    $trialId: TrialID!
    $countryCode: CountryCode!
    $postalCode: String!
    $localeCode: LocaleCode
  ) {
    trial(id: $trialId) {
      id
      closestTrialSite(
        criteria: {
          useNewPatientDetails: {
            countryCode: $countryCode
            zipCode: $postalCode
          }
          useLongDistanceMatching: false
        }
      ) {
        id
        trial {
          id
        }
        consent(localeCode: $localeCode) {
          template {
            version
          }
          preamble
          consent
          confirmedButtonText
          declinedButtonText
          privacyPolicyUrl
          privacyPolicyOrgName
          localeCode
          sites {
            trialSiteId
            name
          }
        }
      }
    }
  }
`;

export type TrialSiteWithConsent = {
  id: number;
  trial: {
    id: string;
  };
  consent: {
    template: {
      version: number;
    };
    preamble: string;
    consent: string;
    confirmedButtonText: string;
    declinedButtonText: string;
    privacyPolicyUrl: string | null;
    privacyPolicyOrgName: string | null;
    localeCode: string;
    sites: Array<{ trialSiteId: number; name: string }>;
  };
};

type QueryResult = {
  trial: {
    id: string;
    closestTrialSite: TrialSiteWithConsent;
  };
};

export function useNearestTrialSite(
  trialId: string | undefined,
  countryCode: string,
  postalCode: string | undefined,
  localeCode: string,
) {
  const { data, loading, error } = useQuery<QueryResult>(
    GET_NEAREST_TRIAL_SITE,
    {
      variables: { trialId, countryCode, postalCode, localeCode },
      skip: !trialId || !countryCode || !postalCode || !localeCode,
    },
  );

  return { value: data?.trial?.closestTrialSite, loading, error };
}
